import { SportRecordDetailPathSchema } from '@school-manage/schema/path.schema';
import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';

import { SportRecordDetailError } from './-components/error/SportRecordDetailError';
import { SportRecordDetailSkeleton } from './-components/pending/SportRecordDetailSkeleton';
import { SportRecordDetail } from './-components/SportRecordDetail';
import { useSportRecordDetail } from './-logic/useSportRecordDetail';
import { SportRecordDetailContext } from './-logic/useSportRecordDetailContext';

export const Route = createFileRoute('/_authed/record/$recordId/sport')({
  beforeLoad: ({
    context: { queryClient },
    location,
    params: { recordId },
  }) => {
    warnIfOfflineNoCache(location, [
      queryClient.getQueryData(['sports']),
      queryClient.getQueryData([
        'task-submit-record-detail',
        { taskResultUuid: recordId },
      ]),
    ]);
  },
  component: SportRecordDetailPage,
  errorComponent: SportRecordDetailError,
  params: { parse: SportRecordDetailPathSchema.parse },
  pendingComponent: SportRecordDetailSkeleton,
});

function SportRecordDetailPage() {
  return (
    <SportRecordDetailContext.Provider value={useSportRecordDetail()}>
      <SportRecordDetail />
    </SportRecordDetailContext.Provider>
  );
}
